import { render } from "./RequireNewPassword.vue?vue&type=template&id=4e6b7af7"
import script from "./RequireNewPassword.vue?vue&type=script&lang=js"
export * from "./RequireNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__